if (!window.productSpecsEditorBound) {
  window.productSpecsEditorBound = true;

  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('.product-specs__item');
    if (!item) return;

    const list = item.closest('.product-specs__list--slider');
    if (!list || list.scrollWidth <= list.clientWidth) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    list.scrollTo({
      left: item.offsetLeft,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  });
}
